<div [ngClass]="[
    'card',
    'card-status-' + (summary.status | lowercase)
  ]
" (dblclick)="openChecklist($event)">
  <div class="card-content gap-2">
    <div class="card-header">
      <h3 class="title">{{ summary.name }}</h3>

      <ng-container *ngIf="summary.parameters?.validationDate">
        <div class="validation-date">
          <i class="material-icons">event</i>
          <span>{{ summary.parameters.validationDate }}</span>
        </div>
      </ng-container>
    </div>

    <div class="card-body">

      <!-- FECHAS -->
      <div class="dates">
        <div class="date" *ngIf="summary.createdAt">
          <span class="label">Creado:</span>
          <span>{{ summary.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>

        <div class="date" *ngIf="summary.updatedAt">
          <span class="label">Actualizado:</span>
          <span>{{ summary.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>

        <div class="date" *ngIf="summary.sendetAt">
          <span class="label">Enviado:</span>
          <span>{{ summary.sendetAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>

      <!-- TAGS -->
      <div class="tags">
        <div class="tag" *ngFor="let tag of summary.tags">
          {{ tag }}
        </div>
      </div>

    </div>
  </div>

  <!-- FOOTER -->
  <div class="card-footer">
    <div class="status status-{{ summary.status | lowercase }}">
      {{
        summary.status === 'pending' ? 'Pendiente' :
        summary.status === 'completed' ? 'Completado' :
        summary.status === 'sent' ? 'Enviado' :
        summary.status
      }}
    </div>
    <button class="btn-edit" (click)="openOptionsMenu($event)">
      <i class="fas fa-ellipsis-v"></i>
    </button>
  </div>

</div>
